export enum FormLayoutSectionAlign {

	ALIGN_VERTICAL = 'ALIGN_VERTICAL',
	ALIGN_HORIZONTAL = 'ALIGN_HORIZONTAL',
	ALIGN_BOTTOM = 'ALIGN_BOTTOM'
}
